
    <!-- <label>{{field.templateOptions.label}}</label> -->

    <ng-select
      [items]="options$ | async"
      [typeahead]="search$"
      [formControl]="formControl"
      [placeholder]="field.templateOptions.placeholder"
      aria-label="{{ field.templateOptions.placeholder }}"
      [multiple]="field.templateOptions.multi"
      bindLabel="{{ field.templateOptions.bindLabel }}"
      bindValue="{{ field.templateOptions.bindValue }}"
      dropdownPosition="bottom"
    >
    </ng-select>
  